var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69066 1.73717L0.205221 12.5641C0.071506 12.7957 0.000754715 13.0582 6.00468e-06 13.3256C-0.000742706 13.593 0.0685372 13.8559 0.200953 14.0882C0.333369 14.3205 0.524306 14.5141 0.754766 14.6497C0.985227 14.7853 1.24718 14.8582 1.51456 14.8612H14.4854C14.7528 14.8582 15.0148 14.7853 15.2452 14.6497C15.4757 14.5141 15.6666 14.3205 15.799 14.0882C15.9315 13.8559 16.0007 13.593 16 13.3256C15.9992 13.0582 15.9285 12.7957 15.7948 12.5641L9.30934 1.73717C9.17284 1.51214 8.98064 1.32608 8.7513 1.19696C8.52195 1.06783 8.2632 1 8 1C7.7368 1 7.47805 1.06783 7.2487 1.19696C7.01936 1.32608 6.82716 1.51214 6.69066 1.73717Z",
    fill: "#F4CE04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.67285V8.73563",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.7988H8.00667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f4720c0ddfab5352be49cb72e36438f6.svg";
export { ForwardRef as ReactComponent };